import { PastSymptomForm } from "~/components/form/health-profile/PastSymptomForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreatePastSymptom() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="past_symptoms">
            <PastSymptomForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
